import React, { useState } from "react";
import { useEffect } from "react";
import {
  Card,
  CardBody,
  Input,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  CardSubtitle,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

import { Colxx } from "../../../components/common/CustomBootstrap";
import userImage from "../../../../src/assets/img/profiles/user.png";
import ThumbnailImage from "../../../../src/components/cards/ThumbnailImage";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { ProfileService } from "../../../services/ProfileService";
import { Stringutility } from "../../../utilities/stringutility";
import { Constants } from "../../../constants/constantValues";

const PeerRatingList = () => {
  const history = useHistory();
  const [modalRight, setModalRight] = useState(false);
  const [showPeerRatingForm, setShowPeerRatingForm] = useState(false);
  const [ispreferedEmail, setPreferedEmail] = useState(true);
  const [peerContactNumber, setPeerContactNumber] = useState("");
  const [selectionId, setSelectionId] = useState("");
  const [showPersonal, setShowPersonal] = useState(false);
  const [showEmployer, setShowEmployer] = useState(false);
  const [experiencesList, setExperiencesList] = useState([]);
  const [requestId, setRequestId] = useState("");
  const [peerRequestList, setPeerRequestList] = useState([]);

  const [workedSameTeam, setWorkedSameTeam] = useState(false);
  const [workedDiffTeams, setWorkedDiffTeams] = useState(false);
  const [youSupervisedPeer, setYouSupervisedPeer] = useState(false);
  const [b2bRelation, setB2bRelation] = useState(false);
  const [customerRelation, setCustomerRelation] = useState(false);
  const [peerSupervisedYou, setPeerSupervisedYou] = useState(false);
  const [mentoringOrTraining, setMentoringOrTraining] = useState(false);
  const [academicRelation, setAcademicRelation] = useState(false);
  const [personalRelation, setPersonalRelation] = useState(false);
  const [expId, setExpId] = useState("");

  const [inputField, setInputField] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    description: "",
  });

  useEffect(() => {
    setInputField((prevState) => ({
      ...prevState,
      description:
        " Can you please rate my skills ? I am using Teamanics, a new career platform that uses peer ratings of skills to match people to jobs.",
    }));
    getCandidateExperiences();
    getReviewDetails();
  }, [0]);

  const navigate = () => {
    const requestId = window.sessionStorage.getItem("request_id");
    history.push({
      pathname: "/peerRatingSkills",
      search: "?id=" + window.sessionStorage.getItem("request_id"),
    });
  };

  const askPeerRating = () => {
    setShowPeerRatingForm(true);
  };

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePreferContact = (event) => {
    if (event.target.value == "Email") {
      setPreferedEmail(true);
    } else {
      setPreferedEmail(false);
    }
  };

  const peerContactHandleChange = (event) => {
    const result = event.target.value.replace(/\D/g, "");
    setPeerContactNumber(result);
  };

  const handleSelectionChange = (e) => {
    setSelectionId(e.target.value);
    if (e.target.value == "personal") {
      setShowPersonal(true);
      setPersonalRelation(true);
      setShowEmployer(false);
      setExpId("");
    } else if (e.target.value == "") {
      setShowPersonal(false);
      setShowEmployer(false);
      setExpId("");
    } else {
      setShowPersonal(true);
      setShowEmployer(true);
      setExpId(e.target.value);
    }
  };

  const updateWorkedSameTeam = () => setWorkedSameTeam(!workedSameTeam);
  const updateworkedDiffTeams = () => setWorkedDiffTeams(!workedDiffTeams);
  const updateYouSupervisedPeer = () =>
    setYouSupervisedPeer(!youSupervisedPeer);
  const updatePeerSupervisedYou = () =>
    setPeerSupervisedYou(!peerSupervisedYou);
  const updateB2BRelation = () => setB2bRelation(!b2bRelation);
  const updateMentoringOrTraining = () =>
    setMentoringOrTraining(!mentoringOrTraining);
  const updateCustomerRelation = () => setCustomerRelation(!customerRelation);
  const updateAcademicRelation = () => setAcademicRelation(!academicRelation);

  const getCandidateExperiences = () => {
    ProfileService.getExperience().then((response) => {
      try {
        if (response.data !== null) {
          var experienceDetails = response.data;
          if (experienceDetails.exps != null) {
            response.data.exps.length > 0 &&
              response.data.exps.map((experience) => {
                const obj = {
                  key: experience.id,
                  value: experience.employer,
                };
                experiencesList.push(obj);
              });
          }
          setExperiencesList(experiencesList);
        }
      } catch (err) {
        console.error("getExperience" + JSON.stringify(err));
      }
    });
  };

  const getReviewDetails = () => {
    const peerReqStatus = "";
    ProfileService.getRatingReview(peerReqStatus).then((response) => {
      try {
        var peerRatingDetails = response.data;
        if (peerRatingDetails != null) {
          if (peerRatingDetails.peerList.length > 0) {
            setPeerRequestList(peerRatingDetails.peerList);
          }
        }
      } catch (err) {
        console.error("getRatingReview" + JSON.stringify(err));
      }
    });
  };

  const sendPeerRequest = (event) => {
     let firstName=Stringutility.getValue(inputField.firstName);
    if (firstName == "") {
      Stringutility.showErrorMessage(Constants.enterFirstName);
      return;
    }

    let lastName=Stringutility.getValue(inputField.lastName);
    if (lastName == "") {
      Stringutility.showErrorMessage(Constants.enterLastName);
      return;
    }


   
    if (ispreferedEmail) {
      let email=Stringutility.getValue(inputField.email);
      if (email == "") {
        Stringutility.showErrorMessage(Constants.enterEmail);
        return;
      }
    } else {
      if (Stringutility.getValue(peerContactNumber) == "") {
        Stringutility.showErrorMessage(Constants.enterPhoneNumber);
        return;
      }
    }

    if (selectionId == 0) {
      Stringutility.showErrorMessage(Constants.howDoYouKnowThisPerson);
      return;
    }
    setModalRight(false);

    const peerRequest = {
      firstName: inputField.firstName,
      lastName: inputField.lastName,
      email: inputField.email,
      contactNumber: peerContactNumber,
      workedSameTeam: workedSameTeam,
      youSupervisedPeer: youSupervisedPeer,
      b2bRelation: b2bRelation,
      customerRelation: customerRelation,
      workedDiffTeams: workedDiffTeams,
      peerSupervisedYou: peerSupervisedYou,
      mentoringOrTraining: mentoringOrTraining,
      academicRelation: academicRelation,
      personalMessage: inputField.description,
      personalRelation: personalRelation,
      expId: expId,
    };

    if (requestId == "") {
      ProfileService.addPeerRating(peerRequest).then((response) => {
        try {
          if (response.data !== null) {
            Stringutility.showSuccessMessage(Constants.peerRequestAddedSuccessfully)

            window.sessionStorage.setItem("request_id", response.data.id);
            setInputField((prevState) => ({
              ...prevState,
              firstName: "",
              lastName: "",
              email: "",
            }));
            setPeerContactNumber("");
            getReviewDetails();
          }
        } catch (err) {
          console.error("addPeerRating" + JSON.stringify(err));
        }
      });
    } else {
      ProfileService.updatePeerRating(peerRequest, requestId).then(
        (response) => {
          try {
            if (response.data !== null) {
              Stringutility.showSuccessMessage(Constants.peerRequestUpdatedSuccessfully)
              setInputField((prevState) => ({
                ...prevState,
                firstName: "",
                lastName: "",
                email: "",
              }));
              setPeerContactNumber("");
              getReviewDetails();
            }
          } catch (err) {
            console.error("updatePeerRating" + JSON.stringify(err));
          }
        }
      );
    }
  };

  const onInvitePeers = (peerRequest) => {
    setModalRight(true);
    setRequestId(peerRequest.requestId);
    setInputField((prevState) => ({
      ...prevState,
      firstName: peerRequest.firstName,
      lastName: peerRequest.lastName,
      email: peerRequest.email,
    }));
    setPeerContactNumber(peerRequest.contactNumber);
    // setShowPeerRatingForm(true);

    setWorkedSameTeam(peerRequest.workedSameTeam);
    setWorkedDiffTeams(peerRequest.workedDiffTeams);
    setYouSupervisedPeer(peerRequest.youSupervisedPeer);
    setPeerSupervisedYou(peerRequest.peerSupervisedYou);
    setB2bRelation(peerRequest.b2bRelation);
    setMentoringOrTraining(peerRequest.mentoringOrTraining);
    setCustomerRelation(peerRequest.customerRelation);
    setAcademicRelation(peerRequest.academicRelation);
  };

  const clearFormData = () => {
    setExpId("");
    setInputField((prevState) => ({
      ...prevState,
      firstName: "",
      lastName: "",
      email: "",
    }));
    setPeerContactNumber("");
    setModalRight(false);
    // setShowPeerRatingForm(false);
    setWorkedSameTeam(false);
    setWorkedDiffTeams(false);
    setYouSupervisedPeer(false);
    setPeerSupervisedYou(false);
    setB2bRelation(false);
    setMentoringOrTraining(false);
    setCustomerRelation(false);
    setAcademicRelation(false);
    setRequestId("");
  };

  return (
    <div className="Container-box">
      <div className="row">
        <div className="col-sm-12">
          <div>
            {/* <div className="skill-header">
                            <div>
                                <div className="profile-card-title">
                                    <label>
                                        <h2>Peer Rating</h2>
                                    </label>
                                </div>
                            </div>
                            <div>
                                <Button
                                    color="primary"
                                    outline
                                    onClick={askPeerRating}>
                                    Ask Peer Rating
                                </Button>
                            </div>
                        </div> */}

            <Modal
              isOpen={modalRight}
              toggle={() => setModalRight(!modalRight)}
              wrapClassName="modal-right"
            >
              <ModalHeader>Ask to peer</ModalHeader>
              <ModalBody>
                <div>
                  <Form>
                    <FormGroup row>
                      <Colxx sm={12}>
                        <FormGroup>
                          <Label for="exampleEmailGrid">First Name*</Label>
                          <Input
                            type="text"
                            name="firstName"
                            data-testid="peerratinglist-firstName"
                            onChange={inputsHandler}
                            value={inputField.firstName}
                            disabled
                          />
                        </FormGroup>
                      </Colxx>

                      <Colxx sm={12}>
                        <FormGroup>
                          <Label for="exampleEmailGrid">Last Name*</Label>
                          <Input
                            type="text"
                            name="lastName"
                            data-testid="peerratinglist-lastName"
                            onChange={inputsHandler}
                            value={inputField.lastName}
                            disabled
                          />
                        </FormGroup>
                      </Colxx>
                    </FormGroup>

                    <FormGroup row>
                      {/* <Colxx sm={12}>
                                            <FormGroup>
                                                <Label for="exampleEmailGrid">
                                                    Prefered Contact Type
                                                </Label>
                                                <Input type="select" onChange={handlePreferContact}>
                                                    <option>Email</option>
                                                    <option>Phone Number</option>
                                                </Input>
                                            </FormGroup>
                                        </Colxx> */}

                      {inputField.email ? (
                        <Colxx sm={12}>
                          <FormGroup>
                            <Label for="exampleEmailGrid">Email*</Label>
                            <Input
                              type="text"
                              name="email"
                              data-testid="peerratinglist-email"
                              onChange={inputsHandler}
                              value={inputField.email}
                              disabled
                            />
                          </FormGroup>
                        </Colxx>
                      ) : (
                        <Colxx sm={12}>
                          <FormGroup>
                            <Label for="exampleEmailGrid">Phone Number*</Label>
                            <Input
                              type="text"
                              name="peerContactNumber"
                              data-testid="peerratinglist-peerContactNumber"
                              onChange={peerContactHandleChange}
                              value={peerContactNumber}
                              disabled
                            />
                          </FormGroup>
                        </Colxx>
                      )}
                    </FormGroup>

                    <FormGroup row>
                      <Colxx sm={12}>
                        <FormGroup>
                          <label>How do you know this person? *</label>
                          <Input
                            type="select"
                            value={selectionId}
                            onChange={handleSelectionChange}
                          >
                            <option value="">Please select</option>
                            <option value="personal">
                              Personal Relationship
                            </option>
                            {experiencesList.length > 0 &&
                              experiencesList.map(({ value, key }) => (
                                <option value={key}>{value}</option>
                              ))}
                          </Input>
                        </FormGroup>
                      </Colxx>
                    </FormGroup>

                    {showEmployer && (
                      <div className="dropzone mb-4">
                        <FormGroup row className="mt-2 ml-2">
                          <Colxx sm={12}>
                            <div className="row form-group">
                              <div className="col-sm-6">
                                <div className="custom-checkbox custom-control custom-control-inline">
                                  <input
                                    type="checkbox"
                                    data-testid="peerratinglist-workedSameTeam"
                                    className="custom-control-input"
                                    name="workedSameTeam"
                                    checked={workedSameTeam}
                                    onChange={updateWorkedSameTeam}
                                  />
                                  <label
                                    className="custom-control-label"
                                    for="workedinthesameteam"
                                  >
                                    Worked in the same team
                                  </label>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="custom-checkbox custom-control custom-control-inline">
                                  <input
                                    type="checkbox"
                                    data-testid="peerratinglist-workedDiffTeams"
                                    className="custom-control-input"
                                    checked={workedDiffTeams}
                                    onChange={updateworkedDiffTeams}
                                  />
                                  <label
                                    className="custom-control-label"
                                    for="exCustomInline"
                                  >
                                    Worked in the different team
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row form-group">
                              <div className="col-sm-6">
                                <div className="custom-checkbox custom-control custom-control-inline">
                                  <input
                                    type="checkbox"
                                    data-testid="peerratinglist-youSupervisedPeer"
                                    className="custom-control-input"
                                    checked={youSupervisedPeer}
                                    onChange={updateYouSupervisedPeer}
                                  />
                                  <label
                                    className="custom-control-label"
                                    for="youSupervisedPeer"
                                  >
                                    You supervised peer
                                  </label>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="custom-checkbox custom-control custom-control-inline">
                                  <input
                                    type="checkbox"
                                    data-testid="peerratinglist-peerSupervisedYou"
                                    className="custom-control-input"
                                    checked={peerSupervisedYou}
                                    onChange={updatePeerSupervisedYou}
                                  />
                                  <label
                                    className="custom-control-label"
                                    for="exCustomInline"
                                  >
                                    peer supervised you
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="row form-group">
                              {" "}
                              <div className="col-sm-6">
                                <div className="custom-checkbox custom-control custom-control-inline">
                                  <input
                                    type="checkbox"
                                    data-testid="peerratinglist-b2bRelation"
                                    className="custom-control-input"
                                    checked={b2bRelation}
                                    onChange={updateB2BRelation}
                                  />
                                  <label
                                    className="custom-control-label"
                                    for="exCustomInline"
                                  >
                                    Business to business relationship
                                  </label>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="custom-checkbox custom-control custom-control-inline">
                                  <input
                                    type="checkbox"
                                    data-testid="peerratinglist-mentoringOrTraining"
                                    className="custom-control-input"
                                    checked={mentoringOrTraining}
                                    onChange={updateMentoringOrTraining}
                                  />
                                  <label
                                    className="custom-control-label"
                                    for="exCustomInline"
                                  >
                                    Mentoring or training relationship
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row form-group">
                              {" "}
                              <div className="col-sm-6">
                                <div className="custom-checkbox custom-control custom-control-inline">
                                  <input
                                    type="checkbox"
                                    data-testid="peerratinglist-customerRelation"
                                    className="custom-control-input"
                                    checked={customerRelation}
                                    onChange={updateCustomerRelation}
                                  />
                                  <label
                                    className="custom-control-label"
                                    for="exCustomInline"
                                  >
                                    Customer relationship
                                  </label>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="custom-checkbox custom-control custom-control-inline">
                                  <input
                                    type="checkbox"
                                    data-testid="peerratinglist-academicRelation"
                                    className="custom-control-input"
                                    checked={academicRelation}
                                    onChange={updateAcademicRelation}
                                  />
                                  <label
                                    className="custom-control-label"
                                    for="exCustomInline"
                                  >
                                    Academic relationship
                                  </label>
                                </div>
                              </div>
                            </div>
                          </Colxx>{" "}
                        </FormGroup>
                      </div>
                    )}

                    {showPersonal && (
                      <FormGroup row>
                        <Colxx sm={12}>
                          <label>
                            Include a personalized message with your request.
                          </label>
                          <Input
                            rows="4"
                            data-testid="peerratinglist-description"
                            type="textarea"
                            name="description"
                            onChange={inputsHandler}
                            value={inputField.description}
                          />
                        </Colxx>
                      </FormGroup>
                    )}

                    <div className="mt-4">
                      <Button
                        color="primary"
                        className="mr-4"
                        onClick={sendPeerRequest}
                      >
                        Send rating request
                      </Button>
                      <Button color="primary" onClick={clearFormData}>
                        Cancel
                      </Button>
                      {/* <Button color="primary" className="ml-4"
                                            onClick={navigate}>
                                            Peer Reviewer
                                        </Button> */}
                    </div>
                  </Form>
                </div>
              </ModalBody>
            </Modal>

            {/* {
                            showPeerRatingForm &&
                           
                        } */}

            <div>
              {peerRequestList.length > 0 && (
                <div className="mt-5">
                  <Colxx md="12" sm="12" lg="12" xxs="12">
                    {peerRequestList.map((peerRequest) => {
                      return (
                        <Card className="d-flex flex-row mb-4 ask-panel-border-radius ">
                          <div className="d-flex">
                            <ThumbnailImage
                              rounded
                              src={userImage}
                              alt="Card image cap"
                              className="m-4"
                            />
                          </div>
                          <div className=" d-flex flex-grow-1 min-width-zero">
                            <CardBody className=" pl-0 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero">
                              <Colxx sm={8}>
                                <CardTitle className="truncate mb-1">
                                  {peerRequest.firstName +
                                    " " +
                                    peerRequest.lastName}
                                </CardTitle>

                                {(() => {
                                  if (peerRequest.email !== "") {
                                    return (
                                      <CardSubtitle className="truncate mb-1">
                                        <i className="iconsminds-envelope review-icon"></i>
                                        {peerRequest.email}
                                      </CardSubtitle>
                                    );
                                  } else if (peerRequest.contactNumber !== "") {
                                    return (
                                      <CardSubtitle className="truncate mb-1">
                                        <i className="simple-icon-phone  review-icon"></i>
                                        {peerRequest.contactNumber}
                                      </CardSubtitle>
                                    );
                                  }
                                })()}

                                {(() => {
                                  if (peerRequest.personalRelation === true) {
                                    return (
                                      <CardSubtitle>
                                        Personal Relation
                                      </CardSubtitle>
                                    );
                                  } else if (
                                    peerRequest.personalRelation === false
                                  ) {
                                    if (peerRequest.expId != "") {
                                      return peerRequest.jobExps.map(
                                        (jobExp) => {
                                          if (peerRequest.expId == jobExp.id) {
                                            return (
                                              <>
                                                <CardSubtitle className="truncate mb-1">
                                                  <i className="simple-icon-briefcase  review-icon"></i>
                                                  {jobExp.position}
                                                </CardSubtitle>

                                                <CardSubtitle className="truncate mb-1">
                                                  <i className="simple-icon-location-pin  review-icon"></i>
                                                  {jobExp.employer}
                                                </CardSubtitle>

                                                <CardSubtitle className="truncate mb-1">
                                                  <i className="simple-icon-calendar review-icon"></i>
                                                  {moment(
                                                    jobExp.startDate
                                                  ).format("YYYY")}
                                                  -
                                                  {moment(
                                                    jobExp.endDate
                                                  ).format("YYYY")}
                                                </CardSubtitle>
                                              </>
                                            );
                                          }
                                        }
                                      );
                                    }
                                  }
                                })()}
                              </Colxx>

                              {(() => {
                                if (
                                  peerRequest.reqStatus.key === "REQ_CREATED" ||
                                  peerRequest.reqStatus.key === "REQ_EMAIL_SENT"
                                ) {
                                  return (
                                    <Colxx
                                      sm={4}
                                      className="justify-content-end"
                                    >
                                      <CardSubtitle className="truncate mb-1">
                                        <Button
                                          color="primary"
                                          size="xs"
                                          onClick={() => {
                                            onInvitePeers(peerRequest);
                                          }}
                                        >
                                          Invite to rate me
                                        </Button>
                                      </CardSubtitle>
                                    </Colxx>
                                  );
                                }
                              })()}
                            </CardBody>
                          </div>
                        </Card>
                      );
                    })}
                  </Colxx>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeerRatingList;
